import { render, staticRenderFns } from "./registrationBi.vue?vue&type=template&id=0032d4ac&scoped=true&"
import script from "./registrationBi.vue?vue&type=script&lang=js&"
export * from "./registrationBi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032d4ac",
  null
  
)

export default component.exports